import urlcat from 'urlcat';

import { SITE_LOCALES, HELPSHIFT_LOCALES } from '@/constants/locales';

import { HELPSHIFT_BASE_URL } from '@/config/external';

function buildSiteUrl(url: string, localeCode: string): string {
  const locale = SITE_LOCALES[localeCode] || SITE_LOCALES.default;

  return urlcat(url, { locale });
}

function buildHelpshiftUrl(localeCode: string): string {
  const l = HELPSHIFT_LOCALES[localeCode];

  return urlcat(HELPSHIFT_BASE_URL, { l });
}

export { buildSiteUrl, buildHelpshiftUrl };
